import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TechDocsAddonLocations } from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';

// TechDocs renders in a shadow root with its own stylesheet. Tokens are inherited, so an
// addon only has to point the document at them.
const STYLE = `
  body, .md-container, .md-main, .md-content {
    background-color: var(--semantics-surfaces-base-background-color) !important;
    color: var(--semantics-content-color);
  }
  .md-typeset :is(h1, h2, h3, h4, h5, h6) {
    color: var(--semantics-content-color);
    font-family: var(--primitives-font-family-sans-serif) !important;
    font-weight: 475;
  }
  .md-typeset a, .md-nav__link { color: var(--semantics-content-accent-color); }
  .md-nav__title {
    background: transparent !important;
    box-shadow: none !important;
    color: var(--semantics-content-color);
  }
`;

const documentStyle = AddonBlueprint.make({
  name: 'huisstijl',
  params: {
    name: 'Huisstijl',
    location: TechDocsAddonLocations.Content,
    component: () => <style>{STYLE}</style>,
  },
});

export const techdocsStyleModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [documentStyle],
});
